













































































import FooterButton from "@/components/FooterButton.vue";
import { Component, Mixins } from "vue-property-decorator";
import {
  AppData,
  INCOME_RANGE,
} from "@/models/app-data";
import CommonMixin, { County } from "@/mixins/common-mixins";
import { ContentService } from "@/service/content.service";
import { WorkflowService } from "@/service/workflow.service";
import { EligibilityService } from "@/service/eligibility.service";
import { QualifierRule, matchQualifiers } from "@/models/rules";
import { AlternateHSQualifierUnder4List2Content } from "@/models/content/alternate-hs-qualifier-under-4-list-2";

@Component({
  components: {
    FooterButton
  }
})
export default class AlternateHSQualifierUnder4List2 extends Mixins(CommonMixin) {
  PercentDone = 80;
  workflowService = new WorkflowService();
  eligibilityService = new EligibilityService();
  content: AlternateHSQualifierUnder4List2Content = {} as AlternateHSQualifierUnder4List2Content;
  specialNeedsChecked = false;
  noneChecked = false;
  appData = {} as AppData;
  textDirection = 'ltr'
  checkTextAlign = 'has-text-left'
  includedZipCodes: Array<string>  = []

  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getAlternateHSQualifierUnder4List2Content();
      this.textDirection = contentService.TextDirection();
      if ( this.textDirection == 'rtl'){
        this.checkTextAlign = 'has-text-right'
      }
      // Import the workflow if one is provided
      await this.loadData();
      if (this.appData != null) {
        this.specialNeedsChecked = this.appData.specialNeeds;
        this.noneChecked = this.appData.hsQualifierUnder4List2None;
        this.putWorkflowStep( this.appData.workflowId, "AlternateHSQualifierUnder4List2") 
      }
    } catch (error) {
      this.showError(error as any);
    }
  }
  async loadData(): Promise<void> {
    if (this.$route?.query?.workflowid != null) {
      const workflowId = this.$route.query.workflowid + "";
      const appData = await this.workflowToAppData(workflowId);
      this.saveAppData(appData);
      this.appData = appData;

      //If we don't have the 250 plus income, redirect
      if (appData.fpl !== INCOME_RANGE.FPL_LVL_3_PLUS) {
        //If we don't have the income, redirect to initial requirements
        if (appData.eligibleIncome == null) {
          this.$router.replace({ path: "InitialRequirements" });
        } else {
          this.$router.replace({ path: "IncomeRange" });
        }
      }
    } else {
      this.appData = this.getAppData();
    }
  }

  optionChanged(e: { target: HTMLInputElement }): void {
    if (this.noneChecked === true) {
      this.noneChecked = false;
    }
  }

  noneChanged(e: { target: HTMLInputElement }): void {
    if (this.noneChecked == true) {
      this.specialNeedsChecked = false;
    }
  }

  public oneOrMoreApplies(): boolean {
    return this.specialNeedsChecked === true;
  }

  public handleNextPageEvent(): void {
    if (this.appData == null) {
      this.appData = {} as AppData;
    }
    this.appData.specialNeeds = this.specialNeedsChecked;
    this.appData.hsQualifierUnder4List2None = this.noneChecked;

    const oneOrMoreApplies = this.oneOrMoreApplies();    

    if (oneOrMoreApplies === true) {
      this.clearGSRPQualifiers(this.appData);
      this.clearGSRPQualifiersList2(this.appData);
      this.clearHSQualifierList3(this.appData);
    }

    this.saveAppData(this.appData);

    this.handleBothUnderAndOverFour();
  
  }

  handleBothUnderAndOverFour(): void {
  const rules: QualifierRule[] = [
      { index: [true, County.Wayne, INCOME_RANGE.FPL_LVL_1_TO_LVL_2], path: 'MatchHSAndGSRPReferral' }
      ,{ index: [true, County.Wayne, INCOME_RANGE.FPL_LVL_2_TO_LVL_3], path: 'MatchHSAndGSRPReferral' }
      ,{ index: [true, County.Wayne, INCOME_RANGE.FPL_LVL_3_PLUS], path: 'MatchHSAndGSRPReferral' }
      ,{ index: [true, County.Macomb, INCOME_RANGE.FPL_LVL_1_TO_LVL_2], path: 'MatchHSAndGSRPReferral' }
      ,{ index: [true, County.Macomb, INCOME_RANGE.FPL_LVL_2_TO_LVL_3], path: 'MatchHSAndGSRPReferral' }
      ,{ index: [true, County.Macomb, INCOME_RANGE.FPL_LVL_3_PLUS], path: 'MatchHSAndGSRPReferral' }
     ,{ index: [false, County.Wayne, INCOME_RANGE.FPL_LVL_1_TO_LVL_2], path: 'MatchNoneCDCLikelyAndGSRPReferral' }
     ,{ index: [false, County.Wayne, INCOME_RANGE.FPL_LVL_2_TO_LVL_3], path: 'MatchNoneAndGSRPReferral' }
     ,{ index: [false, County.Wayne, INCOME_RANGE.FPL_LVL_3_PLUS], path: 'MatchNoneAndGSRPReferral' }
     ,{ index: [false, County.Macomb, undefined], path: 'AlternateHSQualifierUnder4List3' }
  ]

  const rule = matchQualifiers(rules, this.oneOrMoreApplies(), this.appData.county, this.appData.fpl)
  if (rule == null) {
      this.$router.push({ path: 'MatchNone' });
      return;
  }
  this.$router.push({ path: rule.path });
}

  disableNext(): boolean {
    return !(
      this.specialNeedsChecked ||
      this.noneChecked
    );
  }
}
